import axios from 'axios'
import axiosInterceptor from './axiosInterceptor'
import { environment } from '../../environment'

const apiServer = environment.API_URL + '/api/b1/'

const apiClient = axios.create({
  baseURL: apiServer
})

axiosInterceptor.setupInterceptors(apiClient)
export default apiClient
